import { Box, FormControl } from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import React from 'react';
export const OrganizationRoleOrStatusRadioGroup = (props) => {
    return (React.createElement(Box, { p: 2 },
        React.createElement(FormControl, null,
            React.createElement(RadioGroup, { value: props.selected || '', onChange: props.handleChange }, Object.entries(props.items).map(([value, { label }]) => (React.createElement(FormControlLabel, { key: value, value: value, control: React.createElement(Radio, null), label: label, "data-test": `${props.dataTestPrefix}-${value}-radio-button`, sx: { padding: 1 } })))))));
};
